export class TagsModalViewViewModel {
    constructor(props) {
        this.modalTitle = function () {
            let modalTitle = ''
            if (props.modalType === 'delete') {
                modalTitle = "Do you want to delete this configuration?"
            }
            else if (props.modalType === 'create') {
                modalTitle = "Add Configuration"
            }
            else {
                modalTitle = "Edit Configuration"
            }
            return modalTitle
        };

        this.modalWidth = function () {
            let modalWidth = props.modalType === 'delete' ? "sm" : "md";
            return modalWidth
        }

        this.modalContainerClass = function () {
            let modalContainerClass = props.modalType === 'delete' ? "tags-container-delete" : "tags-container";
            return modalContainerClass
        }
    }
}
